import { EventEmitter } from '~utils/event_emitter';

export interface iErrorEvent {
  error: any | null;
  message?: string;
  context?: Record<string, any>;
  uncaught?: boolean;
  silent?: boolean;
}

export interface iErrorEventHandler {
  handle(event: iErrorEvent): void;
}

export const errorEvent = new EventEmitter<iErrorEvent>();
